const Index = () => import(/* webpackChunkName: "dashboard" */ "@/views/dashboard/RelatorioDevolucao/Index");

export default [
  {
    path: "relatorio-devolucao",
    name: "RelatorioDevolucao",
    component: Index,
    meta: {
      title: "Relatório Devolução",
      ensureCanSeeFunctionalities: true,
      permission: {
        name: "relatorioDevolucao",
        action: "read"
      }
    }
  }
];



// WEBPACK FOOTER //
// ./src/router/dashboard/relatorio-devolucao.js